<style lang="scss">
  @import '../resources/scss/news_page.scss';
</style>

<script lang="ts">
  import { locale } from 'svelte-i18n'
  import { useLocation, useParams } from 'svelte-navigator'
  import PaginationNav from 'svelte-paginate/src/PaginationNav.svelte'
  import { writable } from 'svelte/store'
  import Skeleton from '../../node_modules/svelte-skeleton-loader/src/Skeleton.svelte'
  import type News from '../api/rest/directus-cms/news/model/News'
  import CustomSkeleton from '../components/CustomSkeleton.svelte'
  import NewThumbnail from '../components/New_Thumbnail.svelte'
  import { Constants } from '../config/constants'
  import { Slugs } from '../config/slugs'
  import { apiLogin } from '../controllers/AuthController'
  import { fetchNewsLabels, getNewsFromApi } from '../controllers/NewsController'
  import { isNumber } from '../helpers/ValidationHelper'
  import { fallbackLocale } from '../services/i18n'
  import {
    authData,
    documentInnerNewsItems,
    keycloakError,
    newsLabels,
    newsPagination,
    routes
  } from '../stores/stores'

  let lang = $locale ?? fallbackLocale
  let paginationLimit = parseInt(String(process.env.NEWS_PAGINATION_LIMIT))
  let maxNews = process.env.MAX_NEWS ? parseInt(String(process.env.MAX_NEWS)) : 100
  let pagNavLimit: any = 1
  let newsLabelsData: News
  let maxNumberOfPages = Math.ceil(maxNews / paginationLimit)
  const loadedNews = writable(false)
  const loadedLabels = writable(false)

  const params = useParams()
  const location = useLocation()

  if (
    ($params.pageNumber && !isNumber($params.pageNumber)) ||
    parseInt($params.pageNumber) > maxNumberOfPages
  ) {
    window.location.href = $routes.get(lang + Constants.DOUBLE_BARS + Slugs.News)!
  }

  let currentPage = parseInt($params.pageNumber) ? parseInt($params.pageNumber) : 1
  const offset = (currentPage - 1) * (paginationLimit ? paginationLimit : 6)
  const pageSize = paginationLimit ? paginationLimit : 0
  let items: number[] = new Array(maxNews).fill(1)
  let skeletonElements = [1, 2, 3, 4, 5, 6]

  void fetchNewsLabels(lang).then(() => {
    loadedLabels.set(true)
    void apiLogin().then(() => {
      void getNewsFromApi(lang, $authData, pageSize, offset).then(() => {
        items = [
          ...Array(
            $newsPagination.total == undefined
              ? 1
              : $newsPagination.total >= maxNews
              ? maxNews
              : $newsPagination.total
          ).keys()
        ]
        newsLabelsData = $newsLabels!
        loadedNews.set(true)
      })
    })
  })

  function setPageHandler(e: CustomEvent) {
    let news = $location.pathname.split(Constants.SLASH, 3)[2] ?? ''
    let pageNumber = String(e.detail.page) ?? ''
    const path = `${Constants.SLASH}${lang}${Constants.SLASH}${news}${Constants.SLASH}${pageNumber}`
    currentPage = e.detail.page
    window.location.href = path
  }
  $: lang = $locale ?? fallbackLocale
</script>

{#if $newsLabels}
  <div class="container-xxl py-section">
    <h2 class="news-page-title mb-0">{$newsLabels?.news_title}</h2>
    {#if $loadedNews}
      {#if $documentInnerNewsItems.length > 0}
        <div class="news-page-row row gx-4 gx-xxl-5">
          {#each $documentInnerNewsItems as newItem, i}
            <div class="col-12 col-sm-6 col-lg-4">
              <NewThumbnail {newItem} {newsLabelsData} />
            </div>
          {/each}
          <div class="pagination d-flex justify-content-center mt-5 px-0">
            <PaginationNav
              totalItems={items.length}
              limit={pagNavLimit}
              {pageSize}
              {currentPage}
              showStepOptions={true}
              on:setPage={setPageHandler}
            >
              <span slot="number" let:value>
                <span class="option-pagination"><span>{value}</span></span>
              </span>
            </PaginationNav>
          </div>
        </div>
      {:else}
        <h1>{$newsLabels?.no_news_info}</h1>
      {/if}
    {:else if $keycloakError}
      <h1>{$newsLabels?.no_news_info}</h1>
    {:else}
      <div class="row gx-4 gx-xxl-5">
        {#each skeletonElements as skeleton, i}
          <div class="col-12 col-sm-6 col-lg-4">
            <CustomSkeleton>
              <div class="skeleton-container" slot="skeleton-content">
                <div class="image mb-2">
                  <Skeleton />
                </div>
                <div class="data mb-3">
                  <Skeleton />
                </div>
                <div class="title mb-3">
                  <Skeleton />
                </div>
                <div class="body mb-3">
                  <Skeleton count={5} />
                </div>
              </div>
            </CustomSkeleton>
          </div>
        {/each}
      </div>
    {/if}
  </div>
{/if}
